<template>
  <div>
    <!-- <a class="btn" @click="toggleShow">set avatar</a> -->
    <vs-button @click="toggleShow" color="primary" type="border" icon="edit"
      >Edit Image</vs-button
    >
    <my-upload
      :field="nameFile"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="300"
      :height="300"
      img-format="png"
      :langExt="langExt"
      noSquare
      :params="params"
    ></my-upload>
    <!-- 
      :headers="headers"
      url="https://swdapi.ddns.net:8094/upload"
     -->
    <!-- <img :src="imgDataUrl" /> -->
  </div>
</template>

<script>
import "babel-polyfill"; // es6 shim
import myUpload from "vue-image-crop-upload/upload-2.vue";

export default {
  props: {
    nameFile: {
      type: String,
      default: "upload",
    },
    mac: {
      type: String,
      default: "",
    },
    onUpload:{
      type:Function
    },
  },
  data() {
    return {
      show: false,
      params: {
        token: "123456798",
        name: "avatar",
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "", // the datebase64 url of created image
      langExt: {
        hint: "Click or drag the file here to upload",
        loading: "Uploading…",
        noSupported:
          "Browser is not supported, please use IE10+ or other browsers",
        success: "Upload success",
        fail: "Upload failed",
        preview: "Preview",
        btn: {
          off: "Cancel",
          close: "Close",
          back: "Back",
          save: "Upload",
        },
        error: {
          onlyImg: "Image only",
          outOfSize: "Image exceeds size limit: ",
          lowestPx: "Image's size is too low. Expected at least: ",
        },
      },
    };
  },
  components: {
    myUpload,
  },
  mounted() {
    const token = this.$session.get("accessToken");
    const herder = { Authorization: "Bearer " + token };
    this.headers = herder;
  },
  methods: {
    //   function convert base64 to file
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      //   console.log(imgDataUrl, field);
      this.imgDataUrl = imgDataUrl;

      //   const token = this.$session.get("accessToken");
      //   const herder = { Authorization: "Bearer " + token };
      //   this.headers = herder;
      //   console.log(this.headers);

      // call func convart image to file
      var file = this.dataURLtoFile(this.imgDataUrl, this.nameFile);

      // set fotmat data before send to database
      const formData = new FormData();
      formData.append("file", file);
      formData.append("mac", this.mac);
      console.log(formData);

      // call API uplaod image
      try {
        this.$API
          .post("upload/tag", formData)
          .then((res) => {
            console.log(res);
            this.$API.get("indoortag/"+this.mac).then((res) => {
              // console.log(res.data[0]);
              
              this.$session.set("image", res.data[0].image);
            });
            this.$vs.notify({
              color: "success",
              title: "Upload Success",
              text: "Upload image complete!",
              position: "top-center",
            });
            this.show = !this.show;
            setTimeout(()=>{

                location.reload();
            },1000)
          })
          .catch((err) => {
            this.$vs.notify({
              color: "danger",
              title: "Upload Fail",
              text: "There is something wrong with the upload system",
              position: "top-center",
            });
          });
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
  },
};
</script>

<style>
</style>